var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clipboard",
    transform: "translate(-889 -492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2965",
    "data-name": "Rectangle 2965",
    transform: "translate(889 492)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61169",
    "data-name": "Group 61169",
    transform: "translate(135.558 -664.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2870",
    "data-name": "Rectangle 2870",
    transform: "translate(756.442 1159.187)",
    fill: "none",
    stroke: "#8e8e8e",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 11.5,
    height: 14.5,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2871",
    "data-name": "Rectangle 2871",
    transform: "translate(759.9 1157.187)",
    fill: "#fff",
    stroke: "#8e8e8e",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H4.2a2,2,0,0,1,2,2V5a0,0,0,0,1,0,0H0A0,0,0,0,1,0,5V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,.75H4.2A1.25,1.25,0,0,1,5.45,2V4.25a0,0,0,0,1,0,0H.75a0,0,0,0,1,0,0V2A1.25,1.25,0,0,1,2,.75Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    x2: 7.116,
    transform: "translate(759.442 1165.302)",
    fill: "none",
    stroke: "#8e8e8e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x2: 4.744,
    transform: "translate(759.442 1169.256)",
    fill: "none",
    stroke: "#8e8e8e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubClipboard);
export default __webpack_public_path__ + "static/media/subClipboard.67a17fd6b023bbd6eb07c5aa6ae05688.svg";
export { ForwardRef as ReactComponent };